

<script setup>
import { computed } from 'vue'
import { getIcon } from '@/tiptap/constants/icons'

const props = defineProps({
  modelValue: { type: Object, default: () => ({}) },
  t: { type: Function, required: true }
})

const emit = defineEmits(['update:modelValue'])

const form = computed({
  get: () => props.modelValue,
  set: val => emit('update:modelValue', val)
})
</script>

<template>
  <VForm>
    <VTextField
      v-model="form.src"
      :label="t('editor.image.dialog.form.link')"
      autofocus
      :prepend-icon="getIcon('linkVariant')"
    />

    <VTextField
      v-model="form.alt"
      :label="t('editor.image.dialog.form.alt')"
      :prepend-icon="getIcon('text')"
    />

    <VCheckbox
      v-model="form.lockAspectRatio"
      :label="t('editor.image.dialog.form.aspectRatio')"
    />
  </VForm>
</template>